import { gql, TypedDocumentNode } from '@apollo/client';

export const GET_JOB_POSITIONS_COUNT: TypedDocumentNode<{ getJobPositionCount: number }> = gql`
  query getJobPositionCount {
    getJobPositionCount
  }
`;
